import { Nullable } from 'global';

import { StageStatus } from '../types';
import { TemplatesState } from '../ui/viewCard/types';
import { AllAttributesTypes, Stage, StageId } from '../api';

export function getCurrentActiveFlowAndDepartment(templatesByFlowId: TemplatesState) {
  const allTemplates = Object.values(templatesByFlowId);

  const notFinishedProcess = allTemplates.find(({ stages }) =>
    Object.values(stages).some(({ fieldValues }) => !fieldValues?.isCompleted)
  );

  return {
    departmentId: notFinishedProcess?.department?.id ?? allTemplates[0].department.id,
    flowId: notFinishedProcess?.businessProcessFlowId ?? allTemplates[0].businessProcessFlowId,
  };
}

export function getCurrentStage(
  activeFlowId: string,
  flows: { businessProcessFlowId: string; currentStage: Nullable<string> }[]
) {
  const flow = flows.find(({ businessProcessFlowId }) => businessProcessFlowId === activeFlowId);
  return flow?.currentStage ?? null;
}

export function isAllStagesForFlowCompleted(templatesByFlowId: TemplatesState, flowId: Nullable<string>) {
  if (!flowId) return false;

  return Object.values(templatesByFlowId[flowId].stages).every(({ fieldValues }) => fieldValues?.isCompleted);
}

export function determineStatus(stage: Stage, activeStage: StageId, viewedStage: Nullable<StageId>): StageStatus {
  if (stage.businessProcessFlowStageId === activeStage) {
    return StageStatus.Current;
  }

  if (stage.businessProcessFlowStageId === viewedStage) {
    return StageStatus.Viewed;
  }

  if (stage?.fieldValues?.isCompleted) {
    return StageStatus.Passed;
  }

  return StageStatus.Future;
}

export function checkIsStageFieldsExist(stage: Nullable<Stage>) {
  return !!stage?.stageFields?.length;
}

export function calcFieldsAmount(stageFields: AllAttributesTypes[] | null) {
  return (Array.isArray(stageFields) ? stageFields : []).reduce(
    (acc, { field, value }) => {
      if (field !== 'checklist' || !Array.isArray(value)) return acc;

      const calc = value.reduce(
        (fieldsCalc, fieldValue) => {
          if (fieldValue?.isRequired) fieldsCalc.required += 1;
          if (fieldValue?.value) fieldsCalc.totalCompleted += 1;
          if (fieldValue?.isRequired && fieldValue?.value) fieldsCalc.requiredComplete += 1;

          return fieldsCalc;
        },
        { required: 0, totalCompleted: 0, requiredComplete: 0 }
      );

      acc.totalFields = value.length;
      acc.requiredFields = calc.required;
      acc.totalCompletedFields = calc.totalCompleted;
      acc.requiredCompletedFields = calc.requiredComplete;

      return acc;
    },
    { totalFields: 0, requiredFields: 0, totalCompletedFields: 0, requiredCompletedFields: 0 }
  );
}
